import React from 'react';
import { daysInMonth, startDayOfMonth, getTodayString } from './CalendarUtils';

/**
 * 달력의 요일 헤더와 날짜 그리드를 렌더링하는 컴포넌트.
 */
const CalendarGrid = ({ viewDate, value, onDateSelect }) => {
    const year = viewDate.getFullYear();
    const month = viewDate.getMonth();
    const totalDays = daysInMonth(year, month);
    const startDay = startDayOfMonth(year, month);
    const todayStr = getTodayString();

    const days = [];

    // 빈 칸 (이전 달 일수)
    for (let i = 0; i < startDay; i++) {
        days.push(
            <div
                key={`empty-${i}`}
                style={{ width: '32px', height: '32px', flexShrink: 0, margin: '1px' }}
            />
        );
    }

    // 실제 날짜
    for (let d = 1; d <= totalDays; d++) {
        const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
        const isSelected = value === dateStr;
        const isToday = todayStr === dateStr;

        days.push(
            <div
                key={d}
                style={{ width: '32px', height: '32px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', margin: '1px' }}
            >
                <button
                    onClick={(e) => { e.stopPropagation(); onDateSelect(year, month, d); }}
                    className={`text-xs font-bold transition-all
                        ${isSelected ? 'text-white shadow-lg scale-110' :
                            isToday ? 'text-blue-600' :
                                'text-gray-600 hover:text-blue-500'}`}
                    style={{
                        width: '32px',
                        height: '32px',
                        padding: 0,
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '12px',
                        border: isToday ? '1px solid #dbeafe' : 'none',
                        backgroundColor: isSelected ? '#2563eb' : isToday ? '#eff6ff' : 'transparent',
                        flexShrink: 0,
                        flexGrow: 0
                    }}
                >
                    {d}
                </button>
            </div>
        );
    }

    return (
        <>
            {/* 요일 헤더 */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 32px)', gap: '1px', width: 'fit-content', margin: '0 auto' }}>
                {['일', '월', '화', '수', '목', '금', '토'].map((day, idx) => (
                    <div
                        key={day}
                        className={`flex items-center justify-center text-[10px] font-bold ${idx === 0 ? 'text-red-400' : idx === 6 ? 'text-blue-400' : 'text-gray-300'}`}
                        style={{ width: '32px', height: '32px' }}
                    >
                        {day}
                    </div>
                ))}
            </div>

            {/* 날짜 그리드 */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 32px)', gap: '1px', width: 'fit-content', margin: '0 auto' }}>
                {days}
            </div>
        </>
    );
};

export default CalendarGrid;
